import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorTemplate, {
  ErrorTemplateCode,
} from 'web-library/stories/template/ErrorTemplate/ErrorTemplate';
import Typography from 'web-library/stories/atom/Typography/Typography';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  link: {
     ...typographyTheme(theme, 'h4'),
  },
  subtitle: {
    color: theme.color.text.textSecondary,
     ...typographyTheme(theme, 'h4'),
  },
}));

const ErrorPage = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ErrorTemplate
      errorCode={500 as ErrorTemplateCode}
      title={<ErrorPageTitle label={t('components->>ServerError.EncounteredSystemError')} />}
      subtitle={
        <>
          <Typography className={classes.subtitle}>
            {t('components->>ServerError.SomethingWentWrong')}{' '}
          </Typography>
        </>
      }
    />
  );
};

export default ErrorPage;
